module.exports = __webpack_public_path__ + "img/p4-1.3905801c.png";